//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/kratosec/actions';
import type { SubmittedForm$Props } from './flowTypes'

class SubmittedForm extends React.Component<SubmittedForm$Props> {
    componentWillUpdate(){
        const { kratosec } = this.props;
    
        if (kratosec.docSubmitted) {
            this.props.docSubmissionCompleted();
        }
    }

    render(){
        return (
            <div className="container">
                <div className="row">
                    <br />
                </div>
                <div className="row">
                    <h3>EC18 Form Data Extraction</h3>
                </div>
                <div className="row">
                    <div className="alert alert-success" role="alert">
                         Your task has been submitted successfully.
                    </div>
                </div>    
            </div>
        )
    }
    
}

const mapStateToProps:any = (state, ownProps) => {
    return {
        kratosec: state.kratosec
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
        docSubmissionCompleted: () => {
         dispatch(actions.docSubmissionCompleted())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(SubmittedForm);


// WEBPACK FOOTER //
// ./src/views/ProjectKratosEC/SubmittedForm.js